import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { DateRange, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import Box from '@mui/material/Box';
import { useTranslationContext } from '../../../../context/TranslationContext';

type Props = {
  value: DateRange<Dayjs> | null;
  handleChange: (newValue: DateRange<Dayjs>) => void;
  userDateFormat?: string; // Formato personalizado
};

const CustomPropertyDateRangePicker = ({ value, handleChange, userDateFormat }: Props) => {
  const t = useTranslationContext();
  // Default date range if value is null
  const initDates: DateRange<Dayjs> = [dayjs(), dayjs()];

  // Determina el formato dinámico
  const dateFormat = (userDateFormat || 'YYYY/MM/DD').toUpperCase();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ overflow: 'visible', paddingTop: '0px' }}>
        <MultiInputDateRangeField
          slotProps={{
            textField: ({ position }) => ({
              label: position === 'start' ? t('contactEdit.from') : t('contactEdit.to'),
              size: 'small',
              sx: {
                width: '100%',
              },
              variant: 'standard',
              inputProps: {
                placeholder: dateFormat, // Agrega un placeholder para mostrar el formato esperado
              },
            }),
          }}
          value={value || initDates} // Usa initDates como valor predeterminado si value es null
          onChange={(newValue) => handleChange(newValue)}
          format={dateFormat} // Aplica el formato dinámico
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CustomPropertyDateRangePicker;
